import { NgModule } from '@angular/core';
import { PickupOverviewItemComponent } from './pickup-overview-item.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    PickupOverviewItemComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PickupOverviewItemComponent
  ]
})
export class PickupOverviewModule { }
